import { _roleType } from '@custom/Utils/constants/appConstants';
import React from 'react'
import RadiologistTable from './RadiologistTable';
import AdminTable from './AdminTable';

const TabularForm = ({selectedYear}) => {
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  return (
    <div>
      {(role == _roleType.radiologist || role === _roleType.pathologist) ? <RadiologistTable selectedYear={selectedYear} /> : <AdminTable selectedYear={selectedYear} />}
    </div>)
}

export default TabularForm
